import { Cost } from "../../../interfaces/costs/costs.interface";

interface props {
  costo: Cost;
}

const CostoNotas = ({ costo }: props) => {
  return (
    <div>
      <p
        style={{
          whiteSpace: "pre-line",
        }}
      >
        {costo.regla?.notes}
      </p>
    </div>
  );
};

export default CostoNotas;
